import { BoxProps, Flex } from "@chakra-ui/react";
import { useSegmentInfo } from ".";
import { DetailField } from "../../components/detailField/DetailField";
import { DetailFieldListBox } from "../../components/detailFieldListBox/DetailFieldListBox";
import { formatPrecisionLabel } from "../../utils/displayGetters";
import { EditKeywordsDropdown } from "./EditKeywordsDropdown";

export const DetailsSummary = ({
  props,
  variant,
}: {
  props?: BoxProps;
  variant?: string;
}) => {
  const { segment } = useSegmentInfo();


  return (
    <Flex direction={"column"} {...props}>
      <DetailField
        label={"Segment Name:"}
        value={segment.name}
        variant={variant ? variant : ""}
      />
      <DetailField
        label={"Start Date:"}
        value={segment.startDate}
        variant={variant ? variant : ""}
      />
      <DetailField
        variant={variant ? variant : ""}
        label={"End Date:"}
        value={segment.endDate ? segment.endDate : "TBD"}
      />
      {segment.keywordExclusionList && (
        <Flex direction={"column"} justifyContent={"flex-start"}>
          <DetailFieldListBox
            variant={variant ? variant : ""}
            label={"Keywords:"}
            value={segment.keywordExclusionList}
            useTag={true}
          />
          <EditKeywordsDropdown segmentId={segment.uniqueId} />
        </Flex>
      )}
      {segment.keywordInclusionList && (
        <Flex direction={"column"} justifyContent={"flex-start"}>
          <DetailFieldListBox
            variant={variant ? variant : ""}
            label={"Keywords:"}
            value={segment.keywordInclusionList}
            useTag={true}
          />
          <EditKeywordsDropdown segmentId={segment.uniqueId} />
        </Flex>
      )}
      {segment.expansionCategories.length > 0 && (
        <DetailFieldListBox
          variant={variant ? variant : ""}
          label={"Precision Categories:"}
          value={formatPrecisionLabel(segment.expansionCategories)}
          useTag={true}
        />
      )}
    </Flex>
  );
};
